module.exports = __webpack_public_path__ + "static/media/envelope-turquoise.4fca8821.svg";